import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { YoutubeCmsInvoice } from '@anytag/graphql';
import { useYoutubeCMSInvoicesTable } from './hooks';

export type YoutubeCMSInvoicesListProps = TableData<YoutubeCmsInvoice>;

export const YoutubeCMSInvoicesList = ({ loading, data = [] }: YoutubeCMSInvoicesListProps) => {
  const { columns } = useYoutubeCMSInvoicesTable();

  return <TableV2 loading={loading} data={data} columns={columns} rowHeight="48px" noTopBorderRadius />;
};
